import React, { Component } from 'react'
import { Link } from 'react-router-dom'

export class BlogItem extends Component {
  render() {
    return (
      <Link to={`/blog/${this.props.url}`}>
        <div className="blog-item col s12 m7 animated fadeIn">
        <span className="card-title-mobile medium-text">{this.props.title}</span>
        <img className="blog-image-mobile" src={this.props.coverImageURL} alt="Blog Cover"/>
        <div className="card horizontal">
          
          <div className="card-image">
            <img className="blog-image" src={this.props.coverImageURL} alt="Blog Cover"/>
          </div>
            <div className="card-stacked">
              <div className="card-content">
                <span className="card-title medium-text">{this.props.title}</span>
                <br />
                <div className="summary">
                  {this.props.summary}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
    )
  }
}

export default BlogItem
